<ng-container *transloco="let t">
  <div class="file-upload-step" [attr.aria-busy]="isDisabled">
    <button
      #backButton
      class="back-button"
      type="button"
      [disabled]="isDisabled"
      [attr.aria-label]="t('lang.back')"
      (click)="requestBack()">
      <mzic-svg src="assets/icons/arrow-left-disabled.svg" />
    </button>

    <div class="step-container">
      <h1 class="step-title">
        {{ t('lang.file_upload_title_' + contextKeySuffix) }}
      </h1>
      <p class="step-description">
        {{ t('lang.file_upload_subtitle_' + contextKeySuffix) }}
      </p>

      @if (failureAnnouncementKey; as failureKey) {
        <div
          class="file-editor-error-summary"
          role="alert"
          aria-live="assertive">
          <p>{{ t(failureKey) }}</p>
          @if (failureFileNames) {
            <p>
              {{
                t('lang.file_upload_failure_files', {
                  files: failureFileNames,
                })
              }}
            </p>
          }
        </div>
      }

      <div class="upload-section">
        <input
          #fileInput
          class="file-input"
          type="file"
          multiple
          [accept]="acceptedTypes.join(',')"
          [disabled]="isMutationDisabled"
          (change)="onFileSelect($event)" />
        <button
          class="upload-area"
          type="button"
          [class.upload-area-dragging]="isDragOver() && !isMutationDisabled"
          [class.disabled]="isMutationDisabled"
          [disabled]="isMutationDisabled"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (drop)="onDrop($event)"
          (click)="fileInput.click()">
          <span class="upload-icon">
            <mzic-svg src="assets/icons/mzic-cloud-upload-outline.svg" />
          </span>
          <span class="upload-text">
            {{ t('lang.file_upload_drag_click') }}
          </span>
          <span class="upload-sub-text">
            {{ t('lang.file_upload_sources_' + contextKeySuffix) }}
          </span>
        </button>

        @if (isOwner) {
          <div class="share-section">
            <span class="share-text">
              {{ t(sharePromptKey, { entity: integrationEntityName }) }}
            </span>
            <button
              class="share-button"
              type="button"
              [disabled]="isMutationDisabled"
              (click)="requestShare()">
              <mzic-svg src="assets/icons/mzic-link.svg" />
              {{ t('lang.file_upload_share_button') }}
            </button>
          </div>
        }
      </div>

      @if (editorState().rows.length > 0) {
        <section class="uploaded-files-section">
          <h2 class="section-title">
            {{
              t('lang.file_upload_files_selected', {
                count: editorState().rows.length,
              })
            }}
          </h2>
          <div class="files-list">
            @for (row of editorState().rows; track row.key) {
              <lib-collection-report-file-card
                [fileName]="displayName(row)"
                [sizeBytes]="row.sizeBytes"
                [status]="cardStatus(row)"
                [action]="cardAction(row)"
                [actionDisabled]="isMutationDisabled"
                (removeFile)="removeRevisionFile(row.key)"
                (retryUpload)="retryRevisionFile(row)" />
            }
          </div>
        </section>
      }
    </div>

    <div class="action-buttons">
      <button
        #primaryButton
        class="continue-button"
        type="button"
        [disabled]="!canPerformPrimaryAction"
        [attr.aria-describedby]="isDisabled ? 'file-editor-live-status' : null"
        (click)="requestPrimaryAction()">
        @if (isDisabled) {
          <mzic-spinner />
        }
        {{
          t(primaryActionLabelKey, {
            count: unresolvedRequiredReportCount,
          }) | uppercase
        }}
      </button>
      <span
        id="file-editor-live-status"
        class="visually-hidden"
        aria-live="polite">
        @if (isDisabled) {
          {{ t(primaryActionLabelKey) }}
        }
      </span>
      @if (isOwner && hasSharedTarget && !skipButtonHidden) {
        <button
          class="skip-button"
          type="button"
          [disabled]="isMutationDisabled"
          (click)="requestSkip()">
          {{ t('lang.file_upload_skip') | uppercase }}
        </button>
      }
    </div>
  </div>
</ng-container>
